import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function LightbulbIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 60" {...props}>
      <title>Lightbulb</title>
      <g>
        <path d="M22.5 52.5C22.5 53.75 23.5 55 25 55H35C36.5 55 37.5 53.75 37.5 52.5V50H22.5V52.5ZM30 5C20.25 5 12.5 12.75 12.5 22.5C12.5 28.5 15.5 33.75 20 36.75V42.5C20 43.75 21 45 22.5 45H37.5C39 45 40 43.75 40 42.5V36.75C44.5 33.5 47.5 28.25 47.5 22.5C47.5 12.75 39.75 5 30 5Z" />
      </g>
    </SvgIcon>
  );
}

export default LightbulbIcon;
